// utils/accessDetector.js
class AccessDetector {
  constructor() {
    this.accessSource = null;
  }

  // 检测访问来源
  detect() {
    // 1. 优先从URL参数获取
    const urlParams = new URLSearchParams(window.location.search);
    const urlSource = urlParams.get('source');
    
    if (urlSource) {
      this.accessSource = urlSource;
      localStorage.setItem('accessSource', urlSource);
      return this.accessSource;
    }

    // 2. 从本地存储获取
    const storedSource = localStorage.getItem('accessSource');
    if (storedSource) {
      this.accessSource = storedSource;
      return this.accessSource;
    }

    // 3. UA检测
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes('wxwork')) {
      this.accessSource = 'wxwork';
    } else if (ua.includes('micromessenger')) {
      this.accessSource = 'wechat';
    } else {
      this.accessSource = 'browser';
    }

    localStorage.setItem('accessSource', this.accessSource);
    return this.accessSource;
  }

  // 判断是否为特定来源
  isWxWork() {
    return this.accessSource === 'wxwork';
  }

  isWeChat() {
    return this.accessSource === 'wechat';
  }

  isBrowser() {
    return this.accessSource === 'browser';
  }

  // 获取当前来源
  getSource() {
    if (!this.accessSource) {
      this.detect();
    }
    return this.accessSource;
  }

  // 清除来源信息（用于切换登录方式）
  clearSource() {
    this.accessSource = null;
    localStorage.removeItem('accessSource');
  }
}

export default new AccessDetector();